import styled, { createGlobalStyle } from "styled-components";
import { PRIMARY } from "../../utils/colors";

export const ProfileDropdownGlobalStyle = createGlobalStyle`
  .profile-header-dropdown .ant-dropdown-menu {
    border-radius: 24px;
    overflow: hidden;
    padding: 0px 0px 4px;
  }
`;

export const HeaderContainer = styled.div`
  background: #ffffff;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eaeaec;
  
  @media (max-width: 991px) {
    padding: 12px 16px;
  }
`;

export const TopRowLogo = styled.img`
  height: 32px;
  cursor: pointer;
  object-fit: contain;
`;

export const SignInButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #111827;
  font-weight: 500;
  cursor: pointer;
  font-size: 16px;
  border: 1.5px solid #E5E7EB;
  border-radius: 100px;
  padding: 4px 16px 4px 4px;
  
  &:hover {
    background: #F9FAFB;
  }
`;

export const SignInAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #E5E7EB;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
`;

export const ProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ProfilePill = styled.div`
  display: flex;
  align-items: center;
  background: #FFEDD5;
  border-radius: 100px;
  padding: 1px 12px 1px 1px;
  cursor: pointer;
`;

export const ProfileAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #F3F4F6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border: 2px solid #FFFFFF;
  overflow: hidden;
  font-size: 20px;
`;

export const ProfileBalance = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: #111827;
  margin-right: 12px;
`;

export const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 4px 16px 4px;
`;

export const DropdownName = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #111827;
  margin-bottom: 0px;
`;

export const DropdownEmail = styled.div`
  color: #6B7280;
  font-size: 12px;
`;

export const DropdownMenuItem = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  padding: 6px 10px;
`;

export const LogoutButton = styled.span`
  color: #EF4444;
  font-weight: 500;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    text-decoration: underline;
  }
`;
